/* eslint-disable */

"use client";
import { useState, useEffect } from "react";
import SocialMediaModal from "../myFav/SocialMediaModal";
import HeroSection from "./hero-section";
import AboutThisHotel from "./about-hotel";
import OverviewSection from "./overview-section";
import OffersAndPackages from "./offer-package";
import PricingSection from "./pricing";
import PlaceOffers from "./place-offers";
import EventTypes from "./event-type";
import SpecifyEvent from "../venuePreview/SpecifyEvent";
import RatingsAndReviews from "./ratingsAndReviews";
import { FaStar, FaMapMarkerAlt, FaRegMap } from "react-icons/fa";
import { CiShare2 } from "react-icons/ci";
import Map from "./map";
import { useSelector } from "react-redux";
import NewFavoriteFolderModal from "../myFav/NewFavoriteFolderModal";
import AddedFavoriteModal from "../myFav/AddedFavoriteModal";
import { toast } from "react-toastify";
import { IoMdHeart, IoMdHeartEmpty } from "react-icons/io";
import { base_URL } from "../../config/config";
import { DeviceType } from "../../hooks/deviceType";
import axios from "axios";
import HotelChildCards from "./HotelChildCards";
import { RxCross2 } from "react-icons/rx";
import { useQuery } from "@tanstack/react-query";
import { getUser } from "../../lib/apis";
import LoginModal from "../shared/custom-modal/login-modal";
import EnquirySuccessfulModel from "../venuePreview/EnquirySuccessfulModel";

// let startTime = Date.now();
let lastActive = Date.now();
let activeTime = 0;

export default function VenueStayPreview({ previewData, breadcrumbPath }) {
	const [numberOfVenues, setNumberOfVenues] = useState(undefined);
	const [childVenues, setChildVenues] = useState([]);
	const deviceType = DeviceType();
	const user = useSelector((state) => state.auth.user);
	// const user1 = JSON.parse(localStorage.getItem("authUser"))?._id;
	const favoriteVenues =
		user?.favoritesFolder?.map((folder) => folder.venuesAndStay).flat() || [];
	// const [customerId, setCustomerId] = useState("");
	const [newFolder, setNewFolder] = useState(false);
	const [favItem, setFavItem] = useState(null);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isModalAddedOpen, setIsModalAddedOpen] = useState(false);
	const [shareModal, setShareModal] = useState(false);
	const [totalActiveTime, setTotalActiveTime] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);
	const [hasMore, setHasMore] = useState(true);
	const [isLoading, setIsLoading] = useState(false);
	const [venueCardTotalCount, setVenueCardTotalCount] = useState(0);
	const [isMobile, setIsMobile] = useState(false);
	const [showLoginModal, setShowLoginModal] = useState(false);
	const [showEnquiryModal, setShowEnquiryModal] = useState(false);

	const isFavorite =
		previewData &&
		favoriteVenues.some((favorite) => favorite.id === previewData?._id);

	const getVenuesNumber = async (currentPage) => {
		try {
			const response = await axios.post(
				`${base_URL}/api/hotels/number-of-venues`,
				{
					hotelName: previewData?.overview?.basicDetails?.hotelName,
				}
			);

			const response2 = await axios.post(
				`${base_URL}/api/hotels/number-of-venues-paginated-cards`,
				{
					hotelName: previewData?.overview?.basicDetails?.hotelName,
					page: currentPage,
					limit: 3,
					mobile: isMobile,
				}
			);
			if (response.data.totalVenues !== 0) {
				setNumberOfVenues(response.data.totalVenues);
				if (currentPage === 1) {
					setChildVenues(response2.data.totalVenuesDetails);
				} else {
					setChildVenues((prev) => {
						const combined = [...prev, ...response2.data.totalVenuesDetails];
						const uniqueById = [];
						const seenIds = new Set();
						for (const item of combined) {
							if (!seenIds.has(item._id)) {
								seenIds.add(item._id);
								uniqueById.push(item);
							}
						}
						return uniqueById;
					});
				}
				setHasMore(response2.data.hasMore);
				setCurrentPage(response2.data.currentPage);
				setVenueCardTotalCount(response2?.data?.totalVenues ?? 0);
			}
		} catch (error) {
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};
	const loadMore = () => {
		if (!isLoading && hasMore) {
			getVenuesNumber(currentPage + 1);
		}
	};
	const showLess = () => {
		if (!isLoading) {
			setChildVenues((prev) => prev.slice(0, 3));
			setCurrentPage(1);
			setHasMore(true);
		}
		const el = document.getElementById("venue_child_cards");
		if (el) {
			el.scrollIntoView({ behavior: "smooth", block: "start" });
		}
	};

	const getFavoriteFolder = async () => {
		try {
			const response = await fetch(
				`${base_URL}/api/auth/get-folders/${user?._id}`
			);

			if (!response.ok) {
				console.log("Failed to fetch Venues");
				return;
			}
			console.log(response, "response");
			const data = await response.json();
			console.log(data, "MyData");
			refetchFav1();
			return data.folders;
		} catch (err) {
			console.log(err);
		}
	};

	const { folders, refetch } = useQuery({
		queryKey: ["favoriteFolder", user?._id],
		queryFn: getFavoriteFolder,
		enabled: !!user?._id, // Ensure the query only runs when these values are available
	});

	useEffect(() => {
		setCurrentPage(1);
		setChildVenues([]);
		setHasMore(true);
		getVenuesNumber(1);
	}, [previewData]);

	const updateActiveTime = () => {
		if (document.visibilityState === "hidden") {
			// User leaves the page
			activeTime += Date.now() - lastActive;
			// console.log(
			//   "Total active time (seconds):",
			//   (activeTime / 1000).toFixed(2)
			// );
			// console.log("Last active (timestamp):", new Date(lastActive));
			// console.log(
			//   "Active time (seconds):",
			//   ((Date.now() - lastActive) / 1000).toFixed(2)
			// );
			// console.log("Device type:", deviceType);
			const sendTime = ((Date.now() - lastActive) / 1000).toFixed(2);
			updateActiveTimeAPI(sendTime);
		} else if (document.visibilityState === "visible") {
			// User returns to the page
			lastActive = Date.now();
		}
	};

	// Attach visibility change listener once
	useEffect(() => {
		const handleVisibilityChange = () => updateActiveTime();
		document.addEventListener("visibilitychange", handleVisibilityChange);

		return () => {
			// Final calculation before cleanup
			activeTime += Date.now() - lastActive;
			// const totalTime = (Date.now() - startTime) / 1000;
			const totalActiveInSeconds = activeTime / 1000;

			// console.log(`Time spent on venue ${previewData?._id}:`);
			// console.log(`- Total time (active + inactive): ${totalTime} seconds`);
			// console.log(`- Active time: ${totalActiveInSeconds} seconds`);

			// Optionally update the state or send analytics here
			setTotalActiveTime(totalActiveInSeconds);

			document.removeEventListener("visibilitychange", handleVisibilityChange);
		};
	}, [previewData?._id, user?._id, deviceType]);
	const updateActiveTimeAPI = async (time) => {
		// console.log("Updating active time...");
		// console.log("Total active time (seconds):", totalActiveTime);
		// const time = totalActiveTime;
		try {
			await axios.post(`${base_URL}/api/impressions/update-impressions`, {
				venueId: previewData?._id,
				venueName: `${previewData?.overview?.basicDetails?.hotelName}`,
				pageVisitTime: time,
				customerId: user?._id || "anonymous",
				vendorId: previewData?.vendorId,
				deviceCategory: deviceType,
				date: new Date().toISOString().split("T")[0],
			});

			// console.log("API response:", response.data);
			// toast.success("Active time updated successfully!");
		} catch (error) {
			console.error("Error updating active time:", error);
			// toast.error("Failed to update active time.");
		}
	};

	useEffect(() => {
		getUserInfo();
	}, []);

	const getUserInfo = async () => {
		const userInfo = await getUser(user?._id);
		let venuesAndStay = [];
		userInfo?.favoritesFolder?.forEach((folder) => {
			if (folder.venues.length > 0) {
				venuesAndStay = [...venuesAndStay, ...folder?.venuesAndStay];
			}
		});
		console.log(userInfo);
		return venuesAndStay;
	};
	const { data: userFavorites, refetch: refetchFav1 } = useQuery({
		queryKey: ["userFavorites1"],
		queryFn: getUserInfo,
		enabled: !!user?._id,
	});

	// handling add/remove favorite
	const handleClickFavorite = async (itemId) => {
		if (!itemId) return;

		if (!user) {
			return toast.error("Please login first");
		}

		const isFavorited =
			userFavorites &&
			userFavorites.find((favorite) => favorite?.id === itemId);

		if (isFavorited) {
			refetch();
			refetchFav1();
			// If already favorited, remove it
			await removeFavorite(itemId);
		} else {
			// If not favorited, add it
			refetch();
			refetchFav1();
			setFavItem(itemId);
			user?.favoritesFolder?.length > 0
				? setIsModalAddedOpen(true)
				: setIsModalOpen(true);
		}
	};

	// remove favorite
	const removeFavorite = async (itemId) => {
		try {
			const response = await axios.post(
				`${base_URL}/api/favorite/remove-favorite`,
				{
					userId: user._id,
					itemId,
				}
			);
			console.log(response, "response");
			if (response?.data?.success) {
				toast.success("Removed from favorites");
				refetchFav1();
				refetch();
			} else {
				toast.error("Failed to remove from favorites");
			}
		} catch (error) {
			console.error(error);
			toast.error("An error occurred while removing from favorites");
		}
	};

	const handleMobileEnquiryClick = () => {
		if (!user) {
			setShowLoginModal(true);
			return;
		}
		setIsModalOpen(true);
	};

	const videos1 = previewData?.photoVideo?.videos;
	const videos2 = previewData?.photoVideo?.videoLinks;
	const allVideos = [...videos1, ...videos2];

	return (
		<>
			{newFolder && (
				<NewFavoriteFolderModal
					isOpen={newFolder}
					onClose={() => {
						setNewFolder(false);
						refetchFav1();
					}}
					itemId={favItem}
					type={"venueAndStay"}
					refetch={refetch}
				/>
			)}
			{user?.favoritesFolder.length > 0 ? (
				<AddedFavoriteModal
					setNewFolder={setNewFolder}
					isOpen={isModalAddedOpen}
					itemId={favItem}
					refetch={refetch}
					data={user?.favoritesFolder}
					type={"venueAndStay"}
					onClose={() => {
						setIsModalAddedOpen(false);
						refetchFav1();
					}}
				/>
			) : (
				<NewFavoriteFolderModal
					isOpen={isModalOpen}
					itemId={favItem}
					refetch={refetch}
					type={"venueAndStay"}
					onClose={() => {
						setIsModalOpen(false);
						refetchFav1();
					}}
				/>
			)}
			<HeroSection
				imagesData={previewData?.photoVideo?.images}
				basicDetails={previewData?.overview?.basicDetails}
				allVideo={allVideos}
				breadcrumbPath={breadcrumbPath}
			/>
			{shareModal && (
				<SocialMediaModal
					isOpen={shareModal}
					onClose={() => setShareModal(false)}
					shareLink={window.location.href}
				/>
			)}
			<div className="md:flex justify-between items-start  w-full  lg:px-[57px] px-6 ">
				<div>
					<div className="flex justify-between items-center mb-4">
						<h2 className="text-3xl font-bold flex gap-4 items-center">
							{previewData?.overview?.basicDetails?.hotelName || "Undefined"}
							<span className="flex gap-2 items-center text-sm text-[#F2C200]">
								{previewData?.overview?.basicDetails?.hotelRating ? (
									Array.from(
										{
											length: previewData?.overview?.basicDetails?.hotelRating,
										},
										(_, i) => <FaStar key={i} />
									)
								) : (
									<FaStar className="text-gray-400" />
								)}
							</span>
						</h2>
					</div>

					<div className="text-gray-600 flex gap-2 items-center mb-4">
						<FaMapMarkerAlt className="inline mr-2" />
						<span className="font-medium underline decoration-2 underline-offset-2">
							{`${previewData?.overview?.locationDetails?.city || ""}, ${
								previewData?.overview?.locationDetails?.area || ""
							}` || "Location Missing"}
						</span>
						<a
							href="#map"
							className="flex ml-1 text-[#FE4747] font-semibold gap-2 items-center"
						>
							<FaRegMap />
							<span className="underline text-[#FE4747] underline-offset-2 decoration-2">
								Show on map
							</span>
						</a>
					</div>
				</div>
				<div className=" flex justify-between items-center gap-4">
					<div
						className="flex justify-center items-center gap-3 border border-black px-6 py-4 rounded-[8px] cursor-pointer"
						onClick={() => setShareModal(true)}
					>
						<CiShare2 className="text-black text-2xl" />
						Share
					</div>
					<div
						className="flex justify-center items-center gap-3 border border-black cursor-pointer px-6 py-4 rounded-[8px]"
						onClick={() => handleClickFavorite(previewData._id, 0)}
					>
						{userFavorites &&
						userFavorites?.find(
							(favorite) => favorite?.id === previewData?._id
						) ? (
							<IoMdHeart className="text-primary text-2xl" />
						) : (
							<IoMdHeartEmpty className="text-primary text-2xl" />
						)}
						Favourite
					</div>
				</div>
			</div>
			<div className="md:flex justify-between items-start w-full lg:px-[57px] px-6 mt-4">
				<div className="md:w-[68%] w-full">
					<OverviewSection data={previewData} numberOfVenues={numberOfVenues} />
					<OffersAndPackages data={previewData?.offerPackage} />
					{/* Suggested once hotel child cards */}
					{childVenues?.length >= 1 && (
						<HotelChildCards
							data={childVenues}
							hasMore={hasMore}
							isLoading={isLoading}
							onLoadMore={loadMore}
							showLess={showLess}
							breadcrumbPath={breadcrumbPath}
							hotelId={previewData?._id}
							venueCardTotalCount={venueCardTotalCount}
							setIsMobile={setIsMobile}
							getVenuesNumber={getVenuesNumber}
						/>
					)}

					<div className="hidden md:block">
						<AboutThisHotel data={previewData} />
					</div>
					<PricingSection data={previewData?.pricing} />
					<PlaceOffers data={previewData} />
					<EventTypes data={previewData} />
					<Map hotel={previewData} />
					{/* <RatingsAndReviews /> */}
				</div>
				<div className="hidden md:block">
					<SpecifyEvent type={"hotel"} data={previewData} />
				</div>
				{/* Enquire Now button */}
				<div className="fixed bottom-0 left-0 w-full bg-white p-4 shadow-md md:hidden">
					<button
						className="w-full bg-red-500 text-white text-lg font-semibold py-3 rounded-md"
						onClick={handleMobileEnquiryClick}
					>
						Enquire Now
					</button>
				</div>

				{/* Bottom Sheet */}
				{isModalOpen && (
					<div className="fixed inset-0 bg-black bg-opacity-50 z-50 md:hidden flex items-end">
						<div className="bg-white w-full rounded-t-2xl p-4 max-h-[80vh] overflow-y-auto animate-slide-up">
							<div className="flex justify-end">
								<button
									onClick={() => setIsModalOpen(false)}
									className="text-2xl font-bold text-gray-600"
								>
									✕
								</button>
							</div>

							{/* SPECIFY EVENT INSIDE MOBILE SIDEBAR */}
							<SpecifyEvent
								type="hotel"
								data={previewData}
								onSuccess={() => {
									setIsModalOpen(false);
									setShowEnquiryModal(true);
								}}
							/>
						</div>
					</div>
				)}
				{showLoginModal && (
					<LoginModal
						isOpen={showLoginModal}
						onClose={() => setShowLoginModal(false)}
					/>
				)}
				{showEnquiryModal && (
					<EnquirySuccessfulModel
						isOpen={showEnquiryModal}
						setIsOpen={setShowEnquiryModal}
					/>
				)}
			</div>
		</>
	);
}
